module.exports = __webpack_public_path__ + "screen_8fe9.jpg";